// Helpers for social platform URLs

import { toTitleCase } from "./stringUtils";

export const PROFILE_PLATFORM = {
  INSTAGRAM: "instagram",
  TIKTOK: "tiktok",
};

export function getProfileImageSrc({ profilePlatform, profileHandle }) {
  switch (profilePlatform) {
    case PROFILE_PLATFORM.INSTAGRAM:
      return `${process.env.REACT_APP_PROFILES_HOST}${profileHandle}.jpg`;
    case PROFILE_PLATFORM.TIKTOK:
      return `${process.env.REACT_APP_PROFILES_HOST_TIKTOK}${profileHandle}.jpg`;
    default:
      throw new Error("Unsupported platform for profile image");
  }
}

export function getShortcodeImageSrc({ profilePlatform, shortcodeId }) {
  switch (profilePlatform) {
    case PROFILE_PLATFORM.INSTAGRAM:
      return `${process.env.REACT_APP_SHORTCODES_HOST}${shortcodeId}.jpg`;
    case PROFILE_PLATFORM.TIKTOK:
      return `${process.env.REACT_APP_SHORTCODES_HOST_TIKTOK}${shortcodeId}.jpg`;
    default:
      throw new Error("Unsupported platform for shortcode image");
  }
}

export function getPostUrl({ profilePlatform, profileHandle, shortcodeId }) {
  switch (profilePlatform) {
    case PROFILE_PLATFORM.INSTAGRAM:
      return `https://www.instagram.com/p/${shortcodeId}`;
    case PROFILE_PLATFORM.TIKTOK:
      // Note profile handle can be omitted for TikTok URLs even though it appears
      // in the URL structure
      return `https://www.tiktok.com/@${profileHandle}/video/${shortcodeId}`;
    default:
      throw new Error("Unsupported platform for post URL");
  }
}

export function getProfileUrl({ profilePlatform, profileHandle }) {
  switch (profilePlatform) {
    case PROFILE_PLATFORM.INSTAGRAM:
      return `https://www.instagram.com/${profileHandle}`;
    // Untested - validate with real data before use
    case PROFILE_PLATFORM.TIKTOK:
      return `https://www.tiktok.com/@${profileHandle}`;
    default:
      throw new Error("Unsupported platform for profile URL");
  }
}

export function getFriendlyPlatformCreditName(platformCreditSettings) {
  return platformCreditSettings.type.split("_").map(toTitleCase).join(" ");
}
